import { Box, Flex, FlexProps } from '@chakra-ui/react'
import { SimpleFormFooter } from '@components/forms/FinalForm/SimpleForm'
import { ThemeProvider } from '@contexts/ThemeProvider'
import { useProfile } from '@contexts/user/ProfileContext'
import { useApp } from '@hb/react'
import {
  LabResultFlag,
  logLabResultField,
  SaveLabResultArgs,
  serializeLabResult,
  UploadProgress,
} from '@hb/shared'
import { FORM_ERROR } from 'final-form'
import { memo, useCallback, useState } from 'react'
import { saveLabResult } from '../../../../backend/functions/gyn'
import { InnerForm } from '../../../forms/FinalForm/InnerForm'
import { FormElement } from '../../../forms/Input'

const INITIAL_DATA: { flagStatus: LabResultFlag } = { flagStatus: 'normal' }

// const SubmitButton = () => {
//   const { hasValidationErrors, submitting } = useFormState({
//     subscription: { hasValidationErrors: true, submitting: true },
//   })
//   return (
//     <SolidActionButton
//       type="submit"
//       size="sm"
//       fontFamily="Hero-New"
//       isLoading={submitting}
//       isDisabled={hasValidationErrors}>
//       Save Result
//     </SolidActionButton>
//   )
// }

interface FormContentProps {
  onCancel?: () => void
}
const formFooterFlexProps: FlexProps = {
  px: 3,
  bg: 'gray.50',
  _dark: { bg: 'gray.800' },
}
const FormContent = memo(({ onCancel }: FormContentProps) => (
  <Flex h="100%" direction="column">
    <Box px={3} py={2} flex={1} minH={0} overflowY="auto" w="100%">
      <FormElement root showName={false} field={logLabResultField} name="" />
      {/* <Flex justify="flex-end" gap={2} pt={2} borderTop="1px solid" borderColor="gray.100">
      {onCancel ? (
        <Button variant="ghost" size="sm" fontFamily="Hero-New" onClick={onCancel}>
          Cancel
        </Button>
      ) : null}
      <SubmitButton />
    </Flex> */}
    </Box>
    <SimpleFormFooter
      flexProps={formFooterFlexProps}
      submitText="Save Result"
      onCancel={onCancel}
    />
  </Flex>
))

interface Props {
  assessmentId: string | null
  patientId: string
  recordType?: 'maternal' | 'neonatal'
  onSuccess?: () => void
  onCancel?: () => void
}

export const LogLabResultForm = ({
  assessmentId,
  patientId,
  recordType,
  onSuccess,
  onCancel,
}: Props) => {
  const { appName } = useApp()
  const { practiceId } = useProfile()
  const [, setUploads] = useState<Record<string, UploadProgress> | null>(null)

  const handleSubmit = useCallback(
    async (values: Record<string, unknown>) => {
      if (!practiceId) return { [FORM_ERROR]: 'Practice not loaded' }
      try {
        const serialized = serializeLabResult(values)
        const args: SaveLabResultArgs = {
          labResultId: null,
          assessmentId,
          patientId,
          practiceId,
          appName,
          ...(recordType ? { recordType } : {}),
          ...serialized,
        }
        await saveLabResult(args)
        onSuccess?.()
      } catch (err) {
        console.error('Failed to save lab result', err)
        return { [FORM_ERROR]: 'Failed to save lab result' }
      }
    },
    [practiceId, assessmentId, patientId, recordType, appName, onSuccess],
  )

  return (
    <ThemeProvider theme="detailed">
      <InnerForm
        field={logLabResultField}
        data={INITIAL_DATA}
        onSubmit={handleSubmit}
        setUploads={setUploads}
        closeOnSuccess
        onClose={onCancel}>
        {() => <FormContent onCancel={onCancel} />}
      </InnerForm>
    </ThemeProvider>
  )
}
